require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./study-ellis-whittam-azure-portal-and-devops.json") })
        }
      }, "path---study-ellis-whittam-azure-portal-and-devops");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---study-ellis-whittam-azure-portal-and-devops!./.cache/json/study-ellis-whittam-azure-portal-and-devops.json
// module id = 925
// module chunks = 231608221292675